module.exports = __webpack_public_path__ + "img/twitter.2a1ad687.png";